import { Checkbox, ListItemText } from "@material-ui/core";
import { FilterSelect, FilterMenuItem } from "../../styles";

const STATUS_OPTIONS = [
  { value: false, name: "Активний" },
  { value: true, name: "Чернетка" },
];

interface StatusFilterProps {
  label: string;
  selectedValue: boolean | null;
  onChange: (value: boolean | null) => void;
}

export const StatusFilter = ({ label, selectedValue, onChange }: StatusFilterProps) => {
  const selectedValues: boolean[] =
    selectedValue === null ? [false, true] : [selectedValue];

  const handleChange = (values: boolean[]) => {
    if (values.length === 0 || values.length === STATUS_OPTIONS.length) {
      onChange(null);
    } else {
      onChange(values[0]);
    }
  };

  return (
    <FilterSelect
      multiple
      displayEmpty
      value={selectedValues}
      renderValue={() => label}
      variant="outlined"
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => handleChange(e.target.value as boolean[])}
    >
      {STATUS_OPTIONS.map(({ value, name }) => (
        <FilterMenuItem key={name} value={value as any}>
          <Checkbox checked={selectedValues.includes(value)} />
          <ListItemText primary={name} />
        </FilterMenuItem>
      ))}
    </FilterSelect>
  );
};
